import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Table,
  Input,
  Select,
  Form,
  Tooltip,
  Col,
  Spin,
  Radio,
  Row,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import { getRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { useNavigate } from "react-router-dom";
import PurchaseRequisitionSites from "./PurchaseRequisitionSites";
import PropTypes from "prop-types";
const { Panel } = Collapse;

const NewCitywiseAssignPurchaseDetails = ({ PRid }) => {
  const [siteName, setSiteName] = useState([]);
  const navigate = useNavigate();
  const { Option } = Select;
  const [pincodeList, setPincodeList] = useState([]);
  // const [loading, setLoading] = useState(false);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoading2, setBtnLoading2] = useState(false);
  const [view, setView] = useState("");
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const { id, prId } = useParams();
  const formRef = useRef();

  const [estimatedValueFromApi, setEstimatedValueFromApi] = useState([
    {
      id: "",
      value: "",
    },
  ]);
  const [tableData, setTableData] = useState([]);

  const [stateWBS, setStateWBS] = useState([]);

  const initialState = {
    company: CompanyID,
    category_tree: id,
    total_amount: null,
    purchase_requisition_details: [],
  };
  const [state, setState] = useState([]);

  // const [siteWiseTotal, setSiteWiseTotal] = useState({
  //   siteName: "",
  //   total: "",
  // });

  const [siteWiseTotalAmount, setSiteWiseTotalAmount] = useState({
    siteName: "",
    total: "",
  });

  const [siteTotalQuantities, setSiteTotalQuantities] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [cityLength, setCityLength] = useState(1);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [apiLoading, setapiLoading] = useState(false);
  const [viewOption, setViewOption] = useState(false);
  const [prView, setPRView] = useState(null);

  const [overallTotal, setOverallTotal] = useState(0);
  // const [state, setState] = useState([])

  // useEffect(() => {
  //   document.addEventListener("contextmenu", (e) => {
  //     e.preventDefault();
  //   });
  // }, []);

  const getSubCategory = async () => {
    setapiLoading(true);

    try {
      // let apiResponse = await getRequest(
      //   `category-item-setting/1/get-pr-material-by-city/`
      // );
      let apiResponse = await getRequest(`purchase-requisition/${PRid}/`);

      // setEstimatedValueFromApi((estimatedValueFromApi) => [
      //   ...estimatedValueFromApi,
      //   ...apiResponse.data.data.map((item) => ({
      //     id: item.id,
      //     value: item.estimated_unit_price,
      //   })),
      // ]);
      if (apiResponse.data.success) {
        setState(apiResponse.data.data);
        setPRView(apiResponse?.data?.data?.pr_type);

        const prType = apiResponse.data.data.pr_type || "Material Wise";
        setView(prType);

        // if(apiResponse?.data?.data?.pr_type === "City Wise"){
        // setView(prType);
        formRef.current.setFieldsValue({
          pr_view: prType,
        });
        // }
        // else{
        // setView("Material Wise")
        // }
      }

      if (apiResponse.data.data) {
        const purchaseRequisitionDetails = apiResponse.data.data.map((item) => {
          // const siteWise = siteName.map((site) => ({
          //   site_name: site.id,
          //   quantity: null, // Set the initial quantity to null or whatever default value you need
          // }));
          // return {
          //   material_type: item.id,
          //   unit_of_measurement: 1,
          //   total_quantity: 0,
          //   site_wise: siteWise,
          // };
        });
        setState((prevState) => ({
          ...prevState,
          purchase_requisition_details: purchaseRequisitionDetails,
        }));
        // Filter out unique subcategories
        const uniqueSubCategories = Array.from(
          new Set(apiResponse.data.data.map((item) => item.sub_category))
        );

        // Set the state with unique subcategories
        setSubCategoryList(uniqueSubCategories);
        setSubCategoryData(apiResponse.data.data);
        setapiLoading(false);
        // setTimeout(() => setapiLoading(false), 1000);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
      setapiLoading(false);
      // setTimeout(() => setapiLoading(false), 1000);
    } catch (error) {
      setapiLoading(false);
      // setTimeout(() => setapiLoading(false), 1000);
    }
  };

  useEffect(() => {
    getSubCategory();
    getCurrency();
    getUnitOfMeasurement();
    if (siteName.length === 0) {
      getSiteName();
    }
  }, [id, prId]);

  let updateTableData = [];

  // updateTableData = (state) => {
  //   console.log("state 148 ", state);
  //   setapiLoading(true);
  //   const tableData = [];
  //   const length = state?.city_site_material_data?.length;
  //   // const length = 2;

  //   setCityLength(length);

  //   state?.city_site_material_data?.forEach((city, cityIndex) => {
  //     console.log("city 07 ", city);

  //     const cityRowSpan = city.site_wise_pr.length;
  //     let cityTotalQuantity = 0;
  //     let cityTotal = 0;
  //     // cityTotal += cityTotalQuantity;

  //     city.site_wise_pr.forEach((site, siteIndex) => {
  //       let siteTotalQuantity = 0;
  //       let siteMaterialTotal = 0;
  //       site.site_total_quantity += siteTotalQuantity;

  //       site.pr_material_details?.forEach((material) => {
  //         siteTotalQuantity += material.pr_material_type_quantity;
  //         siteMaterialTotal += material.pr_material_type_quantity * 105;
  //         // material.estimated_material_unit_price;
  //       });
  //       site.site_total_quantity = siteTotalQuantity;

  //       setSiteTotalQuantities((prevQuantities) => [
  //         ...prevQuantities,
  //         siteTotalQuantity,
  //       ]);

  //       cityTotalQuantity += siteTotalQuantity;
  //       cityTotal += siteMaterialTotal;

  //       tableData.push({
  //         key: `${cityIndex}-${siteIndex}`,
  //         // srNo: siteIndex === 0 ? cityIndex + 1 : null,
  //         srNo:
  //           length > 1
  //             ? siteIndex === 0
  //               ? cityIndex + 1
  //               : null
  //             : siteIndex + 1,
  //         cityName: siteIndex === 0 ? city.city_name : null,
  //         cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
  //         siteName: site.site_name,
  //         siteLocations: site.pr_material_details?.map(
  //           (material, matIndex) => ({
  //             availableBudget: material.available_budget || 0,
  //             estimatedPRValue: 185 || 0,
  //             remark: material.remark,
  //             materialName: material.pr_material_type_name,
  //             quantity: material.pr_material_type_quantity,
  //             // siteTotalQuantity: siteTotalQuantity,
  //             uom: material.pr_material_type_uom_id,
  //             subCategory: material.pr_material_type_sub_category,
  //             siteIndex,
  //             matIndex,
  //             cityId: city.city_name,
  //             siteId: site.pr_site_id,
  //             estimatedPrice: material.estimated_material_unit_price,
  //           })
  //         ),
  //         totalAmount: (
  //           <Input
  //             disabled
  //             // value={`\u20B9 ${5658 || 0}`}
  //             className="site-subtotal"
  //             // readOnly
  //           />
  //         ),
  //         // siteTotalQuantity: (
  //         //   <Input
  //         //     disabled
  //         //     value={siteTotalQuantity || 0}
  //         //     className="site-total-quantity"
  //         //     readOnly
  //         //   />
  //         // ),
  //       });

  //       // Add site-sub-total row
  //       tableData.push({
  //         key: `${cityIndex}-${siteIndex}-SiteSubTotal`,
  //         siteName: "Site Sub-Total",
  //         siteLocations: [
  //           {
  //             totalQuantity: siteMaterialTotal,
  //             materialName: "",
  //             quantity: siteTotalQuantity,
  //             subCategory: "",
  //             siteIndex,
  //             matIndex: 0,
  //             cityId: city.city_id,
  //             siteId: site.site_id,
  //           },
  //         ],
  //         totalAmount: (
  //           <Input
  //             disabled
  //             value={`\u20B9 ${siteTotalQuantity || 0}`}
  //             className="site-subtotal"
  //             // readOnly
  //           />
  //         ),
  //         siteTotalQuantity: (
  //           <Input
  //             disabled
  //             value={siteTotalQuantity || 0}
  //             className="site-total-quantity"
  //             readOnly
  //           />
  //         ),
  //       });

  //       // Add city total row at the end of the city's site list
  //       if (length > 1) {
  //         if (siteIndex === city.site_wise_pr.length - 1) {
  //           tableData.push({
  //             key: `${cityIndex}-${siteIndex}-CityTotal`,
  //             siteName: "City Total",
  //             siteLocations: [
  //               {
  //                 materialName: "",
  //                 cityTotal: cityTotal,
  //                 quantity: cityTotalQuantity,
  //                 subCategory: "",
  //                 siteIndex,
  //                 matIndex: 0,
  //                 cityId: city.city_id,
  //                 siteId: site.site_id,
  //               },
  //             ],
  //             totalAmount: (
  //               <Input
  //                 disabled
  //                 value={`\u20B9 ${cityTotalQuantity || 0}`}
  //                 className="subtotal"
  //                 readOnly
  //               />
  //             ),
  //             cityTotalQuantity: (
  //               <Input
  //                 disabled
  //                 value={city.city_total_quantity || 0}
  //                 className="city-total-quantity"
  //                 readOnly
  //               />
  //             ),
  //           });
  //         }
  //       }
  //     });

  //     city.city_total_quantity = cityTotal;
  //   });
  //   setTableData(tableData);
  //   setapiLoading(false);
  // };

  //   }

  updateTableData = (state) => {
    // setapiLoading(true);
    const tableData = [];
    const length = state?.city_site_material_data?.length;
    // const length = 2;

    setCityLength(length);

    state?.city_site_material_data?.forEach((city, cityIndex) => {
      const cityRowSpan = city.site_wise_pr.length;
      let cityTotalQuantity = 0;
      let cityTotalQuantityByKg = 0;
      let cityTotal = 0;
      // cityTotal += cityTotalQuantity;
      let cityAmount = 0;

      city.site_wise_pr.forEach((site, siteIndex) => {
        let siteTotalQuantity = 0;
        let siteTotalQuantityForKG = 0;
        let siteMaterialTotal = 0;
        site.site_total_quantity += siteTotalQuantity;

        let siteAmount = 0;

        console.log("pr_material_details", site.pr_material_details);
        site.pr_material_details?.forEach((material) => {
          console.log("material890 ", material);

          siteTotalQuantity += material.pr_material_type_quantity;
          siteMaterialTotal += material.pr_material_type_quantity * 105;
          siteTotalQuantityForKG += material.pr_material_type_quantity_by_kg;
          // material.estimated_material_unit_price;
          // siteAmount +=
          //   material.pr_material_type_uom_name === 1
          //     ? material.pr_material_type_quantity *
          //       1000 *
          //       material.estimated_material_unit_price
          //     : material.pr_material_type_quantity *
          //       material.estimated_material_unit_price *
          //       50;
          siteAmount += material.pr_material_type_quantity_by_kg === 0 ?
            material.pr_material_type_quantity *
            material.estimated_material_unit_price : material.pr_material_type_quantity_by_kg *
            material.estimated_material_unit_price;
        });
        site.site_total_quantity = siteTotalQuantity;
        console.log("siteTotalQuantityForKG", siteTotalQuantityForKG);
        setSiteTotalQuantities((prevQuantities) => [
          ...prevQuantities,
          siteTotalQuantity,
        ]);

        cityTotalQuantity += siteTotalQuantity;
        cityTotal += siteMaterialTotal;
        cityTotalQuantityByKg += siteTotalQuantityForKG;
        cityAmount += siteAmount;

        tableData.push({
          key: `${cityIndex}-${siteIndex}`,
          // srNo: siteIndex === 0 ? cityIndex + 1 : null,
          srNo:
            length > 1
              ? siteIndex === 0
                ? cityIndex + 1
                : null
              : siteIndex + 1,
          cityName: siteIndex === 0 ? city.city_name : null,
          cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
          siteName: site.site_name,
          siteLocations: site.pr_material_details?.map((material, matIndex) => {
            console.log("material560 ", material);

            return {
              availableBudget: material.available_budget || 0,
              estimatedPRValue: 185 || 0,
              remark: material.remark,
              materialName: material.pr_material_type_name,
              quantity: material.pr_material_type_quantity,
              quantityForKG: material.pr_material_type_quantity_by_kg,
              // siteTotalQuantity: siteTotalQuantity,
              uom: material.pr_material_type_uom_id,
              uom_name: material.pr_material_type_uom_name,
              subCategory: material.pr_material_type_sub_category,
              siteIndex,
              matIndex,
              cityId: city.city_name,
              siteId: site.pr_site_id,
              estimatedPrice: material.estimated_material_unit_price,

              // amount:
              //   material.pr_material_type_uom_name === 1
              //     ? material.pr_material_type_quantity *
              //       material.estimated_material_unit_price
              //     : material.pr_material_type_quantity *
              //       material.estimated_material_unit_price,
              amount: material.pr_material_type_quantity_by_kg !== 0 ? material.pr_material_type_quantity_by_kg *
              material.estimated_material_unit_price :
                material.pr_material_type_quantity *
                material.estimated_material_unit_price,
            };
          }),
          totalAmount: (
            <Input
              disabled
              // value={`\u20B9 ${5658 || 0}`}
              className="site-subtotal"
              // readOnly
            />
          ),
          // siteTotalQuantity: (
          //   <Input
          //     disabled
          //     value={siteTotalQuantity || 0}
          //     className="site-total-quantity"
          //     readOnly
          //   />
          // ),
        });

        // Add site-sub-total row
        tableData.push({
          key: `${cityIndex}-${siteIndex}-SiteSubTotal`,
          siteName: "Site Sub-Total",
          siteLocations: [
            {
              totalQuantity: siteMaterialTotal,
              materialName: "",
              quantity: siteTotalQuantity,
              quantityForKG: siteTotalQuantityForKG,
              subCategory: "",
              siteIndex,
              matIndex: 0,
              cityId: city.city_id,
              siteId: site.site_id,
              amount: siteAmount,
            },
          ],
          totalAmount: (
            <Input
              disabled
              value={`\u20B9 ${siteTotalQuantity || 0}`}
              className="site-subtotal"
              // readOnly
            />
          ),
          siteTotalQuantity: (
            <Input
              disabled
              value={siteTotalQuantity || 0}
              className="site-total-quantity"
              readOnly
            />
          ),
        });

        // Add city total row at the end of the city's site list
        if (length > 1) {
          if (siteIndex === city.site_wise_pr.length - 1) {
            tableData.push({
              key: `${cityIndex}-${siteIndex}-CityTotal`,
              siteName: "City Total",
              siteLocations: [
                {
                  materialName: "",
                  cityTotal: cityTotal,
                  quantity: cityTotalQuantity,
                  quantityForKG: cityTotalQuantityByKg,
                  subCategory: "",
                  siteIndex,
                  matIndex: 0,
                  cityId: city.city_id,
                  siteId: site.site_id,
                  amount: cityAmount,
                },
              ],
              totalAmount: (
                <Input
                  disabled
                  value={`\u20B9 ${cityTotalQuantity || 0}`}
                  className="subtotal"
                  readOnly
                />
              ),
              cityTotalQuantity: (
                <Input
                  disabled
                  value={city.city_total_quantity || 0}
                  className="city-total-quantity"
                  readOnly
                />
              ),
            });
          }
        }
      });

      city.city_total_quantity = cityTotal;
    });
    setTableData(tableData);
    // setapiLoading(false);
  };

  useEffect(() => {
    // setapiLoading(true);
    updateTableData(state);
    // setapiLoading(false);
  }, [state]);

  const getUnitOfMeasurement = async (data) => {
    // setapiLoading(true);
    await getRequest("get-category-by-uom/?category_tree", data).then(
      (response) => {
        setPincodeList(response.data.results.data);
        // const defaultOption = response.data.results.data.find(
        //   (option) => option.unit_of_measurement === "MT"
        // );
        // console.log('defaultOption ', defaultOption.id);
        // // const defaultUOM = apiResponse.data.data
        // // console.log(response.data.results.data);
      }
    );
    // setapiLoading(false);
  };

  const getSiteName = async () => {
    //setLoading(true);

    try {
      let apiResponse = await getRequest(
        `delivery-address/${CompanyID}/address-by-company/`
      );
      if (apiResponse.data.data) {
        setSiteName(apiResponse.data.data);
        const updatedState = { ...state };
        updatedState.purchase_requisition_details.forEach((detail) => {
          detail.site_wise.forEach((site, index) => {
            site.site_name = apiResponse.data.data[index]
              ? apiResponse.data.data[index].site.id
              : null;
          });
        });

        // const updatedState = { ...state };
        // updatedState.purchase_requisition_details.forEach((detail) => {
        //   // Populate site_wise with site_name from the API response if available
        //   detail.site_wise = apiResponse.data.data.map((site) => ({
        //     site_name: site.id,
        //     quantity: null,
        //   }));
        // });
        setState(updatedState);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
      //setLoading(false);
    } catch (error) {
      //setLoading(false);
    }
  };
  // const getSiteWiseValue = (record, siteName) => {
  //   // Implement the logic to get the value of the site wise data for the given record and siteName
  //   // For example, if site_wise is an array of objects and each object has a property 'site_name' and 'value', you can do:
  //   // const siteWiseItem = record.site_wise.find(item => item.site_name === siteName);
  //   // return siteWiseItem ? siteWiseItem.value : ''; // Assuming 'value' is the property containing the value
  // };

  const subCategoryColumnsWBC = [
    {
      title: "WBS",
      dataIndex: "WBS",
      key: "WBS",
      render: (text, record, rowIndex) => <span>{stateWBS[rowIndex]}</span>,
    },
  ];

  const WBCsiteNameColumns = siteName.map((item, index) => ({
    title: item.site_name,
    dataIndex: `site_name_${index}`,
    key: `site_name_${index}`,
    render: (text, record, rowIndex) => (
      <>
        <Input
          addonBefore={currencySymbol}
          style={{ width: "100%" }}
          value={rowIndex ? siteWiseTotalAmount[item.id] : ""}
          readOnly
        />
      </>
    ),
    width: 170,
  }));

  // const handleInputChange = (e, id, index) => {
  //   const { value } = e.target;

  //   setState((prevState) => {
  //     const newState = { ...prevState };
  //     newState.purchase_requisition_details =
  //       state.purchase_requisition_details.map((detail) => {
  //         if (detail.material_type === id) {
  //           detail.site_wise[index].quantity = value;
  //           // Recalculate total quantity for the specific row
  //           detail.total_quantity = detail.site_wise.reduce(
  //             (acc, site) => acc + (parseFloat(site.quantity) || 0),
  //             0
  //           );
  //         }
  //         return detail;
  //       });
  //     return newState;
  //   });
  // };

  // const handleInputChange = (e, materialId, siteIndex) => {
  //   const { value } = e.target;
  //   console.log("value", value);

  //   setState((prevState) => {
  //     const newState = {
  //       ...prevState,
  //       purchase_requisition_details:
  //         prevState.purchase_requisition_details.map((detail) => {
  //           console.log("99999", detail, "materialId", materialId);
  //           if (detail.material_type === materialId) {
  //             const updatedSiteWise = detail.site_wise.map((site, index) => {
  //               if (index === siteIndex) {
  //                 return { ...site, quantity: value };
  //               }
  //               return site;
  //             });

  //             const totalQuantity = updatedSiteWise.reduce(
  //               (acc, site) => acc + (parseFloat(site.quantity) || 0),
  //               0
  //             );

  //             return {
  //               ...detail,
  //               site_wise: updatedSiteWise,
  //               total_quantity: totalQuantity,
  //             };
  //           }
  //           return detail;
  //         }),
  //     };

  //     return newState;
  //   });
  // };
  const handleInputChange = (e, cityId, siteId, matIndex) => {
    console.log(
      "e",
      e.target.value,
      "cityId",
      cityId,
      "siteId",
      siteId,
      "matIndex",
      matIndex
    );
    const { value } = e.target;
    if (prId) {
      setState((prevState) => {
        const newState = { ...prevState };
        console.log("newState 124 ", newState);
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          console.log("city 01 ", city);
          if (city.city_name === cityId) {
            city.site_wise_pr = city.site_wise_pr.map((site, siteIndex) => {
              console.log("site 01", site);
              if (site.pr_site_id === siteId) {
                console.log("site 10", site);
                site.pr_material_details[matIndex].pr_material_type_quantity =
                  parseFloat(value) || 0;
              }
              return site;
            });
          }
          return city;
        });
        return newState;
      });
    } else {
      setState((prevState) => {
        const newState = { ...prevState };
        console.log("newState 124 ", newState);
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_id === cityId) {
            city.site_wise_details = city.site_wise_details.map(
              (site, siteIndex) => {
                if (site.site_id === siteId) {
                  console.log("site 10", site);
                  site.material_wise_details[matIndex].material_type_quantity =
                    parseFloat(value) || 0;
                }
                return site;
              }
            );
          }
          return city;
        });
        return newState;
      });
    }
  };

  const handleUOMChange = (value, cityId, siteId, matIndex) => {
    if (prId) {
      console.log("state 25 ", state);
      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          console.log("bc", city);
          if (city.city_name === cityId) {
            console.log("ab");
            city.site_wise_pr = city.site_wise_pr.map((site, siteIndex) => {
              console.log("site 84 ", site);
              if (site.pr_site_id === siteId) {
                site.pr_material_details[matIndex].pr_material_type_uom = value;
              }
              return site;
            });
          }
          return city;
        });
        return newState;
      });
    } else {
      console.log("state 26 ", state);

      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_id === cityId) {
            city.site_wise_details = city.site_wise_details.map(
              (site, siteIndex) => {
                if (site.site_id === siteId) {
                  site.material_wise_details[matIndex].material_type_uom =
                    value;
                }
                return site;
              }
            );
          }
          return city;
        });
        return newState;
      });
    }
  };
  const filterItemsBySubCategory = (subCategory) => {
    return subCategoryData.filter((item) => item.sub_category === subCategory);
  };
  // const handleUOMChange = (value, materialId) => {
  //   setState((prevState) => {
  //     const newState = { ...prevState };
  //     newState.purchase_requisition_details =
  //       prevState.purchase_requisition_details.map((item, index) => {
  //         if (item.material_type === materialId) {
  //           return {
  //             ...item,
  //             unit_of_measurement: value,
  //           };
  //         }
  //         return item;
  //       });
  //     return newState;
  //   });
  // };
  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };
  // const wbsBudget = [
  //   {
  //     title: "Sr",
  //     dataIndex: "Sr",
  //     key: "4",
  //     width: 80,
  //     render: (text, record, index) => index + 1,
  //   },
  //   ...subCategoryColumnsWBC,
  //   ...WBCsiteNameColumns,
  //   {
  //     title: "WBS Budget",
  //     dataIndex: "total_amount",
  //     key: "total_amount",
  //     width: 150,
  //     // render: (text, record, index) => {
  //     //   // Check if it's the second row (index === 1)
  //     //   if (index === 1) {
  //     //     // const correspondingRecord = state.purchase_requisition_details.find(
  //     //     //   (item) => item.id === record.id
  //     //     // );

  //     //     const totalQuantity = totalAmountPr ? totalAmountPr || "" : 0;
  //     //     return <p>{totalQuantity}</p>;
  //     //   } else {
  //     //     return null; // Return null to hide the value in other rows
  //     //   }
  //     // },
  //     render: (text, record, index) => {
  //       if (index === 1) {
  //         const totalQuantity = totalAmountPr ? totalAmountPr : 0; // Assuming totalAmountPr contains the total amount
  //         return (
  //           <Input
  //             addonBefore={currencySymbol}
  //             value={`${totalQuantity}`} // Add Rupees symbol to the value
  //             // Disable the input field if necessary
  //           />
  //         );
  //       } else {
  //         return null; // Return null to hide the value in other rows
  //       }
  //     },
  //   },
  //   {
  //     title: "",
  //     dataIndex: "unit_of_measurement",
  //     key: "unit_of_measurement",
  //     width: 150,
  //     //   render: (text, record, rowIndex) => {
  //     //     const defaultOption = pincodeList.find(option => option.unit_of_measurement === 'MT');
  //     //     const defaultValue = defaultOption ? defaultOption.id : undefined;
  //     //     return (
  //     //       <Select
  //     //         style={{ width: '150px' }}
  //     //         defaultValue={defaultValue}
  //     //         onChange={(value) => handleUOMChange(value, record.id - 1)}
  //     //       >
  //     //         {pincodeList.map((option) => (
  //     //           <Option key={option.id} value={option.id}>
  //     //             {option.unit_of_measurement}
  //     //           </Option>
  //     //         ))}
  //     //       </Select>
  //     //     );
  //     //   },
  //   },
  // ];

  const wbsBudget = [
    {
      title: "SR.",
      dataIndex: "srNo",
      fixed: "left",
      width: 100,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      fixed: "left",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    },
    {
      title: "Available Budget",
      dataIndex: "siteLocations",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName !== "City Total" && record.siteName !== "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              {/* {siteLocations.map((site, index) => ( */}
              <div key={1} className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "100%" }}
                  readOnly
                  value={1000000}
                  // onChange={(e) =>
                  //   handleInputChange(
                  //     e,
                  //     site.cityId,
                  //     site.siteId,
                  //     site.matIndex,
                  //     "availableBudget"
                  //   )
                  // }
                />
              </div>
              {/* ))} */}
            </div>
          );
        }
        return null;
      },
    },
    {
      title: "Estimated PR Value",
      dataIndex: "siteLocations",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName === "City Total" || record.siteName === "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "100%" }}
                  value={siteLocations[0].cityTotal}
                  readOnly
                />
              </div>
            </div>
          );
        } else {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              {/* {siteLocations.map((site, index) => ( */}
              <div key={1} className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "100%" }}
                  value={siteLocations[0].estimatedPRValue}
                  readOnly
                  // onChange={(e) =>
                  //   handleInputChange(
                  //     e,
                  //     site.cityId,
                  //     site.siteId,
                  //     site.matIndex,
                  //     "estimatedPRValue"
                  //   )
                  // }
                />
              </div>
              {/* ))} */}
            </div>
          );
        }
      },
    },
  ];

  if (cityLength > 1) {
    wbsBudget.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    });
  }

  const theadWbsBudget = <Table columns={wbsBudget} />;

  // const theadWbsBudget = <Table columns={wbsBudget} />;
  //   const theadColumns = <Table columns={subCategoryColumns} />;
  // const columns = [
  //   {
  //     title: "SR.",
  //     dataIndex: "srNo",
  //     fixed: "left",
  //     width: 100,
  //     // render: (text, record, index) => {
  //     //   let key = record.key;
  //     //   let siteIndexMatch = key.match(/\d+$/);
  //     //   let siteIndex = siteIndexMatch ? siteIndexMatch[0] : null;

  //     //   let prevKey = index > 0 ? tableData[index - 1].key : null;
  //     //   if (key !== prevKey) {
  //     //     return <div className="lblvalue">{siteIndex ? parseInt(siteIndex) + 1 : ''}</div>;
  //     //   } else {
  //     //     return <div className="lblvalue"></div>;
  //     //   }
  //     // },
  //   },
  //   (cityLength > 1) && {
  //     title: "City",
  //     dataIndex: "cityName",
  //     key: "cityName",
  //     width: 150,
  //     render: (text, record, index) => {
  //       if (index === 0 || record.cityName !== tableData[index - 1].cityName) {
  //         return <div className="lblvalue">{text}</div>;
  //       } else {
  //         return <div className="lblvalue" />;
  //       }
  //     },
  //   },
  //   {
  //     title: "Site",
  //     dataIndex: "siteName",
  //     key: "siteName",
  //     fixed: "left",
  //     width: 150,
  //   },
  //   {
  //     title: "Item",
  //     dataIndex: "siteLocations",
  //     fixed: "left",
  //     width: 150,
  //     render: (siteLocations, record) => (
  //       <>
  //         <div
  //           style={{ display: "flex", flexDirection: "column", gap: "10px" }}
  //         >
  //           {siteLocations.map((site, index) => (
  //             <div key={index} className="lblvalue">
  //               {site.materialName}
  //             </div>
  //           ))}
  //         </div>
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Quantity",
  //     dataIndex: "siteLocations",
  //     width: 150,
  //     render: (siteLocations, record) => (
  //       <>
  //         <div
  //           style={{ display: "flex", flexDirection: "column", gap: "10px", marginRight:"20px" }}
  //         >
  //           {siteLocations.map((site, index) => (
  //             <div key={index} className="lblvalue">
  //               <Input
  //                 type="number"
  //                 min={0}
  //                 style={{ width: "100%" }}
  //                 value={site.quantity}
  //                 onChange={(e) =>
  //                   handleInputChange(
  //                     e,
  //                     site.cityId,
  //                     site.siteId,
  //                     site.matIndex
  //                   )
  //                 }
  //               />
  //             </div>
  //           ))}
  //         </div>
  //       </>
  //     ),
  //   },
  //   {
  //     title: "UOM",
  //     width: 150,
  //     dataIndex: "siteLocations",
  //     render: (siteLocations, record) => {
  //       console.log('record 01', record);
  //       const defaultOption = pincodeList.find(
  //         (option) => option.unit_of_measurement === "MT"
  //       );
  //       const defaultValue = defaultOption ? defaultOption.id : 1;
  //       if(record.siteName === 'City Total' || record.siteName === 'Site Sub-Total'){
  //         return ''
  //       }
  //       return (
  //       <>
  //         <div
  //           style={{
  //             display: "flex",
  //             flexDirection: "column",
  //             gap: "10px",
  //             // marginLeft: "20px",
  //           }}
  //         >
  //           {siteLocations.map((site, index) => (
  //             <div key={index}>
  //               <Select
  //                 style={{ width: "100%" }}
  //                 defaultValue={defaultValue}
  //                 onChange={(value) => handleUOMChange(
  //                   value,
  //                   site.cityId,
  //                   site.siteId,
  //                   site.matIndex
  //                   )}
  //               >
  //                 {pincodeList.map((option) => (
  //                   <Option key={option.id} value={option.id}>
  //                     {option.unit_of_measurement}
  //                   </Option>
  //                 ))}
  //               </Select>
  //             </div>
  //           ))}
  //         </div>
  //       </>
  //     )},
  //   },
  //   {
  //     title: "Total Amount",
  //     dataIndex: "siteLocations",
  //     width: 150,
  //     render: (siteLocations, record) => {
  //       console.log('siteLocations 99', siteLocations, 'record', record);
  //       return (
  //       <>
  //         <div
  //           style={{ display: "flex", flexDirection: "column", gap: "10px",  marginLeft: "20px" }}
  //         >
  //           {siteLocations.map((site, index) => {
  //             let total = site.quantity * site.estimatedPrice;
  //             let totalAmount = site.totalQuantity;
  //             if(site.materialName !== ""){
  //               return (
  //               <div key={index} className="lblvalue">
  //                 <Input
  //                   type="number"
  //                   min={0}
  //                   style={{ width: "100%" }}
  //                   value={total ? total : ''}
  //                   // onChange={(e) =>
  //                   //   handleInputChange(
  //                   //     e,
  //                   //     site.cityId,
  //                   //     site.siteId,
  //                   //     site.matIndex
  //                   //   )
  //                   // }
  //                 />

  //               </div>
  //             )}
  //             if(record.siteName === "City Total"){
  //               console.log('record ', record ,'siteLocations 62', siteLocations)
  //               return (
  //               <div key={index} className="lblvalue">
  //                 <Input
  //                   type="number"
  //                   min={0}
  //                   style={{ width: "100%" }}
  //                   value={site.cityTotal}
  //                   // onChange={(e) =>
  //                   //   handleInputChange(
  //                   //     e,
  //                   //     site.cityId,
  //                   //     site.siteId,
  //                   //     site.matIndex
  //                   //   )
  //                   // }
  //                 />

  //               </div>
  //             )
  //             }
  //             else {
  //               return (
  //               <div key={index} className="lblvalue">
  //                 <Input
  //                   type="number"
  //                   min={0}
  //                   style={{ width: "100%" }}
  //                   value={totalAmount ? totalAmount: ''}
  //                   // onChange={(e) =>
  //                   //   handleInputChange(
  //                   //     e,
  //                   //     site.cityId,
  //                   //     site.siteId,
  //                   //     site.matIndex
  //                   //   )
  //                   // }
  //                 />

  //               </div>
  //             )}

  //             }
  //           )}
  //         </div>
  //       </>
  //     )},
  //   }
  // ];

  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      fixed: "left",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      fixed: "left",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return <div className="subtotal">{"Sub total"}</div>;
        } else if (record.siteName === "City Total") {
          return <div className="citytotal">{"City total"}</div>;
        } else {
          return <>{record.siteName}</>;
        }
      },
    },
    {
      title: "Item",
      dataIndex: "siteLocations",
      fixed: "left",
      width: 190,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.materialName}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "siteLocations",
      fixed: "right",
      width: 120,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return <></>;
        } else if (record.siteName === "City Total") {
          return <></>;
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  // marginRight: "20px",
                  marginLeft: "5px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div key={index} className="lblvalue">
                    {site.quantity}
                  </div>
                ))}
              </div>
            </>
          );
        }
      },
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Preferred Unit of measurement means Your company buys material
              generally in this unit of measurement
            </span>
          }
        >
          Preferred UoM.
        </Tooltip>
      ),
      width: 120,
      dataIndex: "siteLocations",
      render: (siteLocations, record) => {
        const defaultOption = pincodeList.find(
          (option) => option.unit_of_measurement === "MT"
        );
        const defaultValue = defaultOption ? defaultOption.id : 1;
        if (
          record.siteName === "City Total" ||
          record.siteName === "Site Sub-Total"
        ) {
          return "";
        }
        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {siteLocations.map((site, index) => (
                <div
                  key={index}
                  className="lblvalue"
                  style={{ marginLeft: "5px" }}
                >
                  {/* {site.uom} */}
                  {site?.uom_name === "Cubic Meter" ? "Cu. Mtr." : site?.uom_name}
                </div>
              ))}
            </div>
          </>
        );
      },
    },
    {
      title: "Qty. In Kg",
      dataIndex: "siteLocations",
      width: 100,
      // className: 'column-right',
      align: "right",
      render: (siteLocations, record) => {
        console.log("record001 ", record);

        if (record.siteName === "Site Sub-Total") {
          // return (
          //   <>
          //     <div
          //       className="subtotal"
          //       style={{
          //         display: "flex",
          //         flexDirection: "column",
          //         gap: "10px",
          //         float: "inline-end",
          //         // marginRight: "5px",
          //         //marginLeft: "5px"
          //       }}
          //     >
          //       {siteLocations.map((site, index) => (
          //         <span key={index} className="">
          //           {site.quantityForKG.toLocaleString()}
          //         </span>
          //       ))}
          //     </div>
          //   </>
          // );
        } else if (record.siteName === "City Total") {
          // return (
          //   <>
          //     <div
          //       className="citytotal"
          //       style={{
          //         display: "flex",
          //         flexDirection: "column",
          //         gap: "10px",
          //         float: "inline-end",
          //         // marginRight: "20px",
          //         //marginLeft: "5px"
          //       }}
          //     >
          //       {siteLocations.map((site, index) => (
          //         <span key={index} className="">
          //           {site.quantityForKG.toLocaleString()}
          //         </span>
          //       ))}
          //     </div>
          //   </>
          // );
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                  //marginLeft: "5px"
                  marginRight: "5px",
                }}
              >
                {siteLocations.map((site, index) => {
                  console.log("site101 ", site);
                  return (
                    <div key={index} className="">
                      {site.subCategory === "RMC" ? '-' : site.quantityForKG.toLocaleString()}
                    </div>
                  );
                })}
              </div>
            </>
          );
        }
      },
    },
    {
      title: "Est. Amount",
      dataIndex: "amount",
      key: "amount",
      width: 150,
      align: "right",

      render: (text, record) => {
        if (record.siteName === "Site Sub-Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                className="subtotal"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                  // marginRight: "20px",
                  //marginLeft: "5px"
                }}
              >
                {record.siteLocations.map((site, index) => {
                  console.log("fdsite698 ", site, "record", record);
                  return (
                    <div key={index} className="">
                      ₹ {site.amount ? site.amount?.toLocaleString("en-IN", {
                              maximumFractionDigits: 0,
                            }) : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        } else if (record.siteName === "City Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                className="citytotal"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                  // marginRight: "20px",
                  //marginLeft: "5px"
                }}
              >
                {record.siteLocations.map((site, index) => {
                  console.log("site698 ", site, "record", record);
                  return (
                    <div key={index} className="">
                      ₹ {site.amount ? site.amount.toLocaleString() : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        } else {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "flex-end",
                  marginRight: "5px",
                }}
              >
                {record.siteLocations.map((site, index) => {
                  console.log("site698 ", site, "record", record);
                  return (
                    <div key={index} className="lblvalue">
                      ₹ {site.amount ? site.amount.toLocaleString() : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Remarks",
      dataIndex: "siteLocations",
      // width: 150,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.remark}
              </div>
            ))}
          </div>
        </>
      ),
    },
  ];

  if (cityLength > 1) {
    columns.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text, record, index) => {
        if (index === 0 || record.cityName !== tableData[index - 1].cityName) {
          return <div className="lblvalue">{text}</div>;
        } else {
          return <div className="lblvalue" />;
        }
      },
    });
  }

  const theadPR = <Table columns={columns} />;

  const colors = ["#094E8F"];
  return (
    <>
      <Spin spinning={apiLoading}>
        <section className="grid-sec mt-5">
          <div className="PR-body tbl-collapse">
            {
              <>
                <Collapse defaultActiveKey={["1"]} className="scroll5">
                  <Panel header={theadPR} key="1">
                    <Table
                      columns={columns}
                      dataSource={tableData}
                      pagination={false}
                      scroll={{ x: "auto" }}
                    />
                  </Panel>
                </Collapse>
              </>
            }
          </div>
        </section>
      </Spin>
    </>
  );
};

NewCitywiseAssignPurchaseDetails.propTypes = {
  PRid: PropTypes.number,
};

export default NewCitywiseAssignPurchaseDetails;
